import ScooterImgDescSwiper from "../../components/swiper/ScooterImgDescSwiper";
import { SCOOTER_MAIN_DESC_INFO } from "assets/json/scooterInfo.js";

/**
 * @file scooter 화면에서 desc 영역 component
 */
function ScooterMainDesc() {
  return (
    <>
      {SCOOTER_MAIN_DESC_INFO.map((val, i) => (
        <div className={"describe-wrapper-" + i + " scooter-describe-wrapper"} key={"scooter-main-desc-info-" + i}>
          <div className="describe-title">
            <div className="t1" dangerouslySetInnerHTML={{ __html: val.desc_title }}></div>
            <div className="sub" dangerouslySetInnerHTML={{ __html: val.desc_sub }}></div>
          </div>
          <ScooterImgDescSwiper data={val.img_desc} />
        </div>
      ))}
    </>
  );
}

export default ScooterMainDesc;
